import { updatePreset } from '@primevue/themes'

import { ContigoMarketPlacePreset } from '~/theme/preset'

export default defineNuxtRouteMiddleware(async () => {
  updatePreset(ContigoMarketPlacePreset)
})
